import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const show = async (templateId, templateItemId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `template/${templateId}/template-detail/${templateItemId}`,
  })

  return response?.data
}

export const _store = async (templateId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `template/${templateId}/template-detail`,
    data,
  })

  return response?.data
}

export const store = (templateId) => async (data) => await _store(templateId, data)

export const update = async (templateId, templateItemId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `template/${templateId}/template-detail/${templateItemId}`,
    data,
  })

  return response?.data
}

export const _delete = async (templateId, templateItemId) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: `template/${templateId}/template-detail/${templateItemId}`
  })

  return response?.data
}

export const deleteSingle = (templateId) => async (templateItemId) => await _delete(templateId, templateItemId)
